/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { StepType } from '@forgerock/sdk-types';
function getRealm(payload) {
    return payload.realm;
}
function getSessionToken(payload) {
    return payload.tokenId;
}
function getSuccessUrl(payload) {
    return payload.successUrl;
}
function createJourneyLoginSuccess(payload) {
    return {
        payload,
        type: StepType.LoginSuccess,
        getRealm: () => getRealm(payload),
        getSessionToken: () => getSessionToken(payload),
        getSuccessUrl: () => getSuccessUrl(payload),
    };
}
export { createJourneyLoginSuccess, getRealm, getSessionToken, getSuccessUrl };
